import { Link } from "react-router-dom";
import { StatusBadge, BillingBadge, MerchantBadge, Money, Empty } from "@/components/Primitives";
import { fmtDate } from "@/lib/api";

export function BookingsTable({ rows, showAgent = false, testId = "bookings-table", emptyText = "No bookings found." }) {
  if (!rows.length) return <Empty text={emptyText} testId={`${testId}-empty`} />;
  return (
    <div className="panel overflow-x-auto" data-testid={testId}>
      <table className="w-full text-sm">
        <thead className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-800">
          <tr>
            <th className="px-4 py-3">Booking</th>
            <th className="px-4 py-3">Traveler</th>
            <th className="px-4 py-3">Product / Supplier</th>
            {showAgent && <th className="px-4 py-3">Agent</th>}
            <th className="px-4 py-3">Billing</th>
            <th className="px-4 py-3 text-right">Gross</th>
            <th className="px-4 py-3 text-right">Net Cost</th>
            <th className="px-4 py-3 text-right">MCO</th>
            <th className="px-4 py-3">Merchant</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Created</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((b) => (
            <tr key={b.id} className="border-b border-slate-800/70 last:border-0 hover:bg-slate-800/50 transition-colors" data-testid={`booking-row-${b.booking_ref}`}>
              <td className="px-4 py-3"><Link to={`/bookings/${b.id}`} className="font-mono font-semibold text-indigo-300 hover:text-indigo-200" data-testid={`booking-link-${b.booking_ref}`}>{b.booking_ref}</Link></td>
              <td className="px-4 py-3">{b.traveler_name}<div className="text-xs text-slate-500">{b.supplier_ref || "—"}</div></td>
              <td className="px-4 py-3">{b.product_category}<div className="text-xs text-slate-500">{b.supplier_name}</div></td>
              {showAgent && <td className="px-4 py-3 text-slate-300">{b.agent_name}</td>}
              <td className="px-4 py-3"><BillingBadge type={b.billing_type} /></td>
              <td className="px-4 py-3 text-right"><Money value={b.gross_amount} tone="gross" /></td>
              <td className="px-4 py-3 text-right"><Money value={b.supplier_cost} tone="cost" /></td>
              <td className="px-4 py-3 text-right"><Money value={b.mco} tone="mco" /></td>
              <td className="px-4 py-3"><MerchantBadge name={b.payment?.processed_merchant_name || b.target_merchant_name} /></td>
              <td className="px-4 py-3"><StatusBadge status={b.charge_status} locked={b.locked} testId={`row-status-${b.booking_ref}`} /></td>
              <td className="px-4 py-3 text-xs text-slate-500 whitespace-nowrap">{fmtDate(b.created_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
